import {Store} from 'rlink-flux';
import {twitchActions} from 'rlink-twitch/actions';
import {merge} from 'rlink-utils/object';

class TwitchStore extends Store {
  constructor () {
    super();
    this.broadcastGroups = [];
  }

  getFullState () {
    return {
      broadcastGroups: this.broadcastGroups
    };
  }

  getMostActiveBroadcasts (allBroadcasts) {
    let broadcastGroups = [];
    let index = 0;
    allBroadcasts.map((broadcastGroup) => {
      broadcastGroups.push({
        priority: broadcastGroup.get('priority'),
        broadcasts: this.getMostActiveBroadcastsByGroup(index, broadcastGroup.get('maxChildren'))
      });
      index += 1;
    });
    return broadcastGroups;
  }

  getMostActiveBroadcastsByGroup (groupId, count) {
    let broadcasts = this.broadcastGroups[groupId] || [];
    broadcasts.sort((b1, b2) => {
      if (b1.priority !== b2.priority) {
        return (b1.priority - b2.priority);
      } else {
        return (b1.age - b2.age) !== 0 ? (b1.age - b2.age) : (b2.views - b1.views);
      }
    });

    return broadcasts.slice(0, count);
  }

  onDispatch (dispatch) {
    let payload = dispatch.payload;
    switch (dispatch.action) {
      case twitchActions.BroadcastLoaded:
        let broadcasts = payload.broadcasts.map(broadcast => {
          return merge(broadcast, {
            priority: payload.priority,
            thumbnail: payload.thumbnail,
          });
        });

        let validBroadcasts = broadcasts.filter(broadcast => {
          return (broadcast.game === payload.gameFilter);
        });

        if (typeof this.broadcastGroups[payload.groupId] !== 'undefined') {
          this.broadcastGroups[payload.groupId] = this.broadcastGroups[payload.groupId].concat(validBroadcasts);
        } else {
          this.broadcastGroups[payload.groupId] = validBroadcasts;
        }

        this.notifyChanged();
        break;
    }
  }
}

export let twitchStore = new TwitchStore();



// WEBPACK FOOTER //
// ./lib/rlink-twitch/store.js